export default __webpack_public_path__ + "static/media/tsch-sim.ff3da96d.png";